import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ba252462"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSlider: require('/opt/build/repo/components/Elements/Slider.vue').default,ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default})
